import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Field from 'redux-form/lib/Field';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Form from 'react-bootstrap/lib/Form';

import { debounce } from '../../modules/debounce.ts';
import Spinner from '../Spinner';
import FieldFormControl from '../FieldFormControl';
import OnboardingBackButton from '../OnboardingBackButton';
import CreateAccountContainer from '../CreateAccountContainer';

import Box from '../../shared/Box';
import Text from '../../shared/Text';

import styles from '../OnboardingRouter/styles.sass';

const getLoginUrlForFeed = feedUrl =>
  `/login${feedUrl ? `?feedUrl=${encodeURIComponent(feedUrl)}` : ''}`;

class OnboardingCreateAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasChanged: false,
      editingSlug: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.editingSlug &&
      this.props.onboarding.fetchingVanitySlug &&
      !nextProps.onboarding.fetchingVanitySlug
    ) {
      this.setState({ editingSlug: false });
    }
  }

  componentDidMount() {
    this.props.actions.fetchTempVanitySlugFromPodcastName();
    this.handleChangeVanitySlug = debounce(
      this.onChangeVanitySlug.bind(this),
      500
    );
  }

  // TODO: generic text/input controller that propagates onChanges with deboucnes
  onChangeVanitySlug = value => {
    this.props.handleSubmit();
  };

  render() {
    const {
      rssFeed,
      vanitySlug,
      vanitySlugIsAvailable,
      fetchingVanitySlug,
    } = this.props.onboarding;
    const { feedUrl, anyTouched, error, handleSubmit } = this.props;
    const { hasChanged, editingSlug } = this.state;

    const podcastURLEditor = (
      <Form onSubmit={handleSubmit} inline key="podcastUrlEditor">
        <div className={styles.vanityUrlContainer}>
          <p>
            <strong>anchor.fm/</strong>
          </p>
          <Field
            defaultValue={vanitySlug}
            name="vanitySlug"
            component={FieldFormControl}
            type="text"
            onInputChange={e => {
              if (!this.state.hasChanged || !this.state.editingSlug) {
                this.setState({ hasChanged: true, editingSlug: true });
              }
              this.handleChangeVanitySlug(e);
            }}
          />
        </div>
        <div className={styles.vanityUrlInfo}>
          {fetchingVanitySlug || editingSlug ? (
            <Spinner color="gray" size={19} />
          ) : !hasChanged ? (
            <p className={styles.vanityUrlTip}>
              Tip: you can customize this URL.
            </p>
          ) : vanitySlugIsAvailable ? (
            <p style={{ color: '#27DE56' }}>Looks good!</p>
          ) : (
            <p style={{ color: '#FF6663' }}>Sorry, that URL is unavailable.</p>
          )}
        </div>
      </Form>
    );

    return (
      <div className={styles.onboardingPage}>
        <div className={`${styles.pageContent} `}>
          <Row>
            <Col xs={12}>
              <div className={styles.signupPage}>
                <Box marginBottom={10}>
                  <h1 key="RSStitle">Sign up for Anchor</h1>
                </Box>
                <Box marginBottom={50}>
                  <Text size="xl" color="#292f36">
                    Already have an account?{' '}
                    <Text size="xl" color="#8940fa" isBold isInline>
                      <Link to={getLoginUrlForFeed(feedUrl)}>Log in</Link>{' '}
                    </Text>
                    instead.
                  </Text>
                </Box>
                {podcastURLEditor}
                <CreateAccountContainer feedUrl={feedUrl} />
                <OnboardingBackButton className={styles.backButton} />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default OnboardingCreateAccount;
